module.exports = __webpack_public_path__ + "img/linkedin.6d9df42c.svg";